(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ht-instagram"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ig-carousel]').forEach(function(root){
  if(root.dataset.igReady) return; root.dataset.igReady='1';
  var track=root.querySelector('[data-ig-track]');
  var prev=root.querySelector('[data-ig-prev]');
  var next=root.querySelector('[data-ig-next]');
  if(!track) return;
  var originals=Array.prototype.slice.call(track.children);
  var n=originals.length;
  function step(){var s=originals[0];if(!s)return 0;var gap=parseFloat(getComputedStyle(track).columnGap)||0;return s.getBoundingClientRect().width+gap;}

  /* Pocas fotos: si todas caben a la vez, se muestran centradas y quietas (sin repetir ninguna). */
  var s0=step();
  var perView=s0?Math.round((track.clientWidth+(parseFloat(getComputedStyle(track).columnGap)||0))/s0):3;
  if(n<=perView){root.classList.add('is-static');return;}

  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Circular: una copia delante y otra detrás; al llegar a una copia se salta sin que se note a la misma foto del bloque central. */
  function makeClone(el){var c=el.cloneNode(true);c.setAttribute('aria-hidden','true');c.setAttribute('tabindex','-1');c.removeAttribute('data-shopify-editor-block');c.classList.add('ig-clone');return c;}
  var before=document.createDocumentFragment(), after=document.createDocumentFragment();
  originals.forEach(function(el){before.appendChild(makeClone(el));after.appendChild(makeClone(el));});
  track.insertBefore(before,track.firstChild);
  track.appendChild(after);

  function setWidth(){return step()*n;}
  function jump(to){track.classList.add('is-jumping');track.scrollLeft=to;void track.offsetWidth;track.classList.remove('is-jumping');}
  function normalize(){var w=setWidth();if(!w)return;var x=track.scrollLeft;if(x<w*0.5)jump(x+w);else if(x>=w*1.5)jump(x-w);}
  function start(){jump(setWidth());}
  start();
  window.addEventListener('load',start,{once:true});
  var rT;window.addEventListener('resize',function(){clearTimeout(rT);rT=setTimeout(function(){var s=step();var i=Math.round(track.scrollLeft/s)%n;jump(setWidth()+i*s);},150);});

  var sT;
  track.addEventListener('scroll',function(){clearTimeout(sT);sT=setTimeout(normalize,140);},{passive:true});
  function go(dir){normalize();track.scrollBy({left:dir*step(),behavior:reduce?'auto':'smooth'});}
  if(prev) prev.addEventListener('click',function(){go(-1);pause(6000);});
  if(next) next.addEventListener('click',function(){go(1);pause(6000);});

  /* Avance automático suave; se para al pasar el ratón, al tocar o si no está en pantalla. */
  var timer=null,hold=false,visible=true,resumeT;
  function tick(){if(!hold&&visible&&!document.hidden)go(1);}
  function play(){if(reduce||timer)return;timer=setInterval(tick,4500);}
  function pause(ms){hold=true;clearTimeout(resumeT);resumeT=setTimeout(function(){hold=false;},ms||6000);}
  root.addEventListener('mouseenter',function(){hold=true;clearTimeout(resumeT);});
  root.addEventListener('mouseleave',function(){hold=false;});
  root.addEventListener('focusin',function(){hold=true;});
  root.addEventListener('focusout',function(){hold=false;});
  track.addEventListener('touchstart',function(){pause(8000);},{passive:true});
  if('IntersectionObserver' in window){new IntersectionObserver(function(e){visible=e[0].isIntersecting;},{threshold:.3}).observe(root);}
  play();

  /* Arrastrar con el ratón en escritorio. */
  var isDown=false,startX=0,startScroll=0,moved=false;
  track.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='mouse') return;
    isDown=true;moved=false;startX=e.clientX;startScroll=track.scrollLeft;hold=true;
  });
  track.addEventListener('pointermove',function(e){
    if(!isDown) return;
    var dx=e.clientX-startX;
    if(Math.abs(dx)>4){moved=true;track.classList.add('is-dragging');}
    track.scrollLeft=startScroll-dx;
  });
  function endDrag(){
    if(!isDown) return;
    isDown=false;track.classList.remove('is-dragging');
    var s=step();
    if(moved&&s) track.scrollTo({left:Math.round(track.scrollLeft/s)*s,behavior:reduce?'auto':'smooth'});
    pause(6000);
  }
  track.addEventListener('pointerup',endDrag);
  track.addEventListener('pointerleave',endDrag);
  track.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ht-results-strip"] && !Shopify.designMode) return;
  try {
    
(function(){
function initRs(scope){
(scope||document).querySelectorAll('[data-rs-carousel]').forEach(function(root){
  if(root.dataset.rsReady) return; root.dataset.rsReady='1';
  var track=root.querySelector('[data-rs-track]'),prev=root.querySelector('[data-rs-prev]'),next=root.querySelector('[data-rs-next]');
  if(!track) return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior=reduce?'auto':'smooth';
  var autoplay=root.dataset.autoplay==='true';
  var ms=Math.max(2,Number(root.dataset.interval)||4)*1000;
  function step(){var s=track.querySelector('.rs-slide');if(!s)return 0;return s.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);}
  function overflows(){return track.scrollWidth>track.clientWidth+4;}
  function atEnd(){return track.scrollLeft>=track.scrollWidth-track.clientWidth-4;}
  function atStart(){return track.scrollLeft<=4;}
  function layout(){root.classList.toggle('is-static',!overflows());}
  function go(dir){
    if(!overflows())return;
    if(dir>0&&atEnd()){track.scrollTo({left:0,behavior:behavior});return;}
    if(dir<0&&atStart()){track.scrollTo({left:track.scrollWidth,behavior:behavior});return;}
    track.scrollBy({left:dir*step(),behavior:behavior});
  }
  var hold=false,visible=true,resumeT;
  function pause(t){hold=true;clearTimeout(resumeT);resumeT=setTimeout(function(){hold=false;},t||7000);}
  if(prev) prev.addEventListener('click',function(){go(-1);pause();});
  if(next) next.addEventListener('click',function(){go(1);pause();});
  layout();
  window.addEventListener('load',layout,{once:true});
  var rT;window.addEventListener('resize',function(){clearTimeout(rT);rT=setTimeout(layout,150);});
  if(autoplay&&!reduce){
    setInterval(function(){if(!hold&&visible&&!document.hidden)go(1);},ms);
    root.addEventListener('mouseenter',function(){hold=true;clearTimeout(resumeT);});
    root.addEventListener('mouseleave',function(){hold=false;});
    root.addEventListener('focusin',function(){hold=true;});
    root.addEventListener('focusout',function(){hold=false;});
    track.addEventListener('touchstart',function(){pause(9000);},{passive:true});
  }
  var vids=Array.prototype.slice.call(track.querySelectorAll('video'));
  function tryPlay(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}
  vids.forEach(function(v){
    v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.loop=true;
    if(reduce){v.controls=true;v.preload='metadata';return;}
    v.addEventListener('click',function(){if(v.paused){tryPlay(v);}else{v.pause();}pause();});
  });
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(e){visible=e[0].isIntersecting;},{threshold:.3}).observe(root);
    if(!reduce){
      var warm=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){var v=e.target;if(v.preload!=='auto')v.preload='auto';warm.unobserve(v);}});},{rootMargin:'400px 700px'});
      var io=new IntersectionObserver(function(entries){entries.forEach(function(e){var v=e.target;if(e.isIntersecting&&e.intersectionRatio>=0.35){if(v.preload!=='auto')v.preload='auto';tryPlay(v);}else{v.pause();}});},{threshold:[0,0.35]});
      vids.forEach(function(v){warm.observe(v);io.observe(v);});
    }
  }
  var down=false,sx=0,ss=0,moved=false;
  track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;sx=e.clientX;ss=track.scrollLeft;});
  track.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4){moved=true;track.classList.add('is-dragging');}track.scrollLeft=ss-dx;});
  function end(){if(!down)return;down=false;track.classList.remove('is-dragging');var s=step();if(moved&&s)track.scrollTo({left:Math.round(track.scrollLeft/s)*s,behavior:behavior});pause();}
  track.addEventListener('pointerup',end);
  track.addEventListener('pointerleave',end);
  track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
});
}
initRs();
document.addEventListener('shopify:section:load',function(e){initRs(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
